module.exports = __webpack_public_path__ + "img/what-happens-desktop.c32aa7e6.png";